/** Installed map engine's default vertical field of view, in degrees. */
export const DEFAULT_VERTICAL_FIELD_OF_VIEW = 2 * Math.atan(1 / 3) * 180 / Math.PI;

/** Compensates range with focal length while retaining transverse target magnification. */
export function nightHawkOptics(slantRangeFactor: number, targetLock: boolean) {
  if (!Number.isFinite(slantRangeFactor) || slantRangeFactor <= 0) throw new RangeError('Sensor slant range must be positive.');
  const focalFactor = targetLock ? slantRangeFactor : 1;
  return {
    zoomOffset: targetLock ? 0 : -Math.log2(slantRangeFactor),
    fieldOfView: 2 * Math.atan(1 / (3 * focalFactor)) * 180 / Math.PI,
    opticalZoomFactor: focalFactor,
  };
}
